// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboardContainer {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #ffffff;
}

.dashboardHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

.logoText {
  color: #FF6F0F;
  font-size: 28px;
  margin: 0;
}

.logoLink {
  text-decoration: none;
}

.headerLeft {
  display: flex;
  align-items: center;
}

.headerRight {
  display: flex;
  align-items: center;
}

.headerRight button {
  margin-left: 10px;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.logoutButton {
  background-color: white !important;
  color: #FF6F0F !important;
  border: 1px solid #FF6F0F !important;
  border-radius: 20px !important;
  padding: 8px 25px !important;
  font-size: 14px;
  transition: all 0.3s;
  width: 146px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logoutButton:hover {
  background-color: #FFF5E9;
}

.contentWrapper {
  display: flex;
  flex-grow: 1;
  background-color: #ffffff;
  height: calc(100vh - 60px);
}

.sideMenu {
  width: 250px;
  background-color: #fffbf8;
  height: 100%;
  border-right: 1px solid #eee;
  position: sticky;
  top: 0;
  left: 0;
  overflow-y: auto;
}

.menuItem {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  color: #333;
  text-decoration: none;
  margin-bottom: 5px;
  transition: background-color 0.3s;
}

.menuItem:hover {
  background-color: #fff0e6;
}

.menuItem.active {
  background-color: #fff0e6;
  color: #FF6F0F;
  border-left: 3px solid #FF6F0F;
}

.menuIconContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

.menuIconContainer.active img {
  filter: invert(55%) sepia(75%) saturate(1642%) hue-rotate(346deg) brightness(101%) contrast(96%);
  /* 이 filter 설정은 이미지를 #FF6F0F 색상으로 변환합니다 */
}

.menuIcon {
  width: 24px;
  height: 24px;
  margin-right: 12px;
  object-fit: contain;
}

.mainContent {
  flex-grow: 1;
  padding: 20px;
  background-color: #ffffff;
  overflow-y: auto;
  height: 100%;
}

.pageHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.pageTitle {
  font-size: 24px;
  margin: 0;
}

.pageActions {
  display: flex;
  gap: 15px;
}

.exportButton, .editButton {
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 8px 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 14px;
}

.exportIcon, .editIcon {
  margin-right: 5px;
}

.monthNavigation {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.prevMonth, .nextMonth {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  color: #666;
}

.currentMonth {
  margin: 0 20px;
  font-size: 20px;
}

.workerTable {
  background-color: #ffffff;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  border: 1px solid #eee;
  padding: 10px;
  text-align: center;
}

th {
  background-color: #fff3eb;
}

tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.overtime-notice {
  background-color: #FFC107;
  padding: 10px 20px;
  border-radius: 5px;
  margin-top: 20px;
  display: inline-block;
  color: #333;
  font-weight: bold;
}

.dashboardTitle {
  color: var(--primary); /* 제목 색상 */
  margin-bottom: 20px;
}

.dashboardHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.headerLeft h2 {
  font-size: 24px;
}

.downloadButton {
  background-color: #FF6F0F; /* 버튼 색상 */
  color: white;
}

.settingsButton {
  background-color: #007BFF; /* 다른 버튼 색상 */
  color: white;
}

.infoSection {
  background-color: white;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.monthlyDetails {
  background-color: white;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.detailsTable {
  width: 100%;
  border-collapse: collapse;
}

.detailsTable th, .detailsTable td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

.summarySection {
  background-color: white;
  padding: 15px;
  border-radius: 8px;
}

/* 대시보드 메인 레이아웃 */
.dashboard {
  display: flex;
  width: 100%;
  height: 100%;
}

/* 사이드바 스타일 */
.sidebar {
  width: 250px; /* 사이드바 고정 너비 */
  min-width: 250px; /* 최소 너비 설정 */
  flex-shrink: 0; /* 크기 축소 방지 */
  z-index: 10; /* 높은 z-index */
  position: relative;
  background-color: #f8f8f8;
}

/* 메인 콘텐츠 영역 */
.mainContent {
  flex: 1 1;
  overflow: hidden; /* 스크롤은 내부 컴포넌트에서 처리 */
  position: relative;
  padding: 20px;
} `, "",{"version":3,"sources":["webpack://./src/styles/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B;EAC9B,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,4BAA4B;EAC5B,gBAAgB;EAChB,MAAM;EACN,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gGAAgG;EAChG,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,qBAAqB,EAAE,UAAU;EACjC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,UAAU;EACrC,YAAY;AACd;;AAEA;EACE,yBAAyB,EAAE,aAAa;EACxC,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA,aAAa;AACb;EACE,YAAY,EAAE,eAAe;EAC7B,gBAAgB,EAAE,aAAa;EAC/B,cAAc,EAAE,aAAa;EAC7B,WAAW,EAAE,eAAe;EAC5B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,SAAO;EACP,gBAAgB,EAAE,sBAAsB;EACxC,kBAAkB;EAClB,aAAa;AACf","sourcesContent":[".dashboardContainer {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background-color: #ffffff;\n}\n\n.dashboardHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #ffffff;\n  padding: 15px 20px;\n  border-bottom: 1px solid #eee;\n}\n\n.logoText {\n  color: #FF6F0F;\n  font-size: 28px;\n  margin: 0;\n}\n\n.logoLink {\n  text-decoration: none;\n}\n\n.headerLeft {\n  display: flex;\n  align-items: center;\n}\n\n.headerRight {\n  display: flex;\n  align-items: center;\n}\n\n.headerRight button {\n  margin-left: 10px;\n  padding: 10px 15px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.logoutButton {\n  background-color: white !important;\n  color: #FF6F0F !important;\n  border: 1px solid #FF6F0F !important;\n  border-radius: 20px !important;\n  padding: 8px 25px !important;\n  font-size: 14px;\n  transition: all 0.3s;\n  width: 146px;\n  height: 44px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.logoutButton:hover {\n  background-color: #FFF5E9;\n}\n\n.contentWrapper {\n  display: flex;\n  flex-grow: 1;\n  background-color: #ffffff;\n  height: calc(100vh - 60px);\n}\n\n.sideMenu {\n  width: 250px;\n  background-color: #fffbf8;\n  height: 100%;\n  border-right: 1px solid #eee;\n  position: sticky;\n  top: 0;\n  left: 0;\n  overflow-y: auto;\n}\n\n.menuItem {\n  display: flex;\n  align-items: center;\n  padding: 15px 20px;\n  color: #333;\n  text-decoration: none;\n  margin-bottom: 5px;\n  transition: background-color 0.3s;\n}\n\n.menuItem:hover {\n  background-color: #fff0e6;\n}\n\n.menuItem.active {\n  background-color: #fff0e6;\n  color: #FF6F0F;\n  border-left: 3px solid #FF6F0F;\n}\n\n.menuIconContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 12px;\n}\n\n.menuIconContainer.active img {\n  filter: invert(55%) sepia(75%) saturate(1642%) hue-rotate(346deg) brightness(101%) contrast(96%);\n  /* 이 filter 설정은 이미지를 #FF6F0F 색상으로 변환합니다 */\n}\n\n.menuIcon {\n  width: 24px;\n  height: 24px;\n  margin-right: 12px;\n  object-fit: contain;\n}\n\n.mainContent {\n  flex-grow: 1;\n  padding: 20px;\n  background-color: #ffffff;\n  overflow-y: auto;\n  height: 100%;\n}\n\n.pageHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n}\n\n.pageTitle {\n  font-size: 24px;\n  margin: 0;\n}\n\n.pageActions {\n  display: flex;\n  gap: 15px;\n}\n\n.exportButton, .editButton {\n  background-color: #ffffff;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  padding: 8px 15px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n}\n\n.exportIcon, .editIcon {\n  margin-right: 5px;\n}\n\n.monthNavigation {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n\n.prevMonth, .nextMonth {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 18px;\n  color: #666;\n}\n\n.currentMonth {\n  margin: 0 20px;\n  font-size: 20px;\n}\n\n.workerTable {\n  background-color: #ffffff;\n  border-radius: 5px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n  overflow-x: auto;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\nth, td {\n  border: 1px solid #eee;\n  padding: 10px;\n  text-align: center;\n}\n\nth {\n  background-color: #fff3eb;\n}\n\ntbody tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.overtime-notice {\n  background-color: #FFC107;\n  padding: 10px 20px;\n  border-radius: 5px;\n  margin-top: 20px;\n  display: inline-block;\n  color: #333;\n  font-weight: bold;\n}\n\n.dashboardTitle {\n  color: var(--primary); /* 제목 색상 */\n  margin-bottom: 20px;\n}\n\n.dashboardHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.headerLeft h2 {\n  font-size: 24px;\n}\n\n.downloadButton {\n  background-color: #FF6F0F; /* 버튼 색상 */\n  color: white;\n}\n\n.settingsButton {\n  background-color: #007BFF; /* 다른 버튼 색상 */\n  color: white;\n}\n\n.infoSection {\n  background-color: white;\n  padding: 15px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n}\n\n.monthlyDetails {\n  background-color: white;\n  padding: 15px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n}\n\n.detailsTable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.detailsTable th, .detailsTable td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: center;\n}\n\n.summarySection {\n  background-color: white;\n  padding: 15px;\n  border-radius: 8px;\n}\n\n/* 대시보드 메인 레이아웃 */\n.dashboard {\n  display: flex;\n  width: 100%;\n  height: 100%;\n}\n\n/* 사이드바 스타일 */\n.sidebar {\n  width: 250px; /* 사이드바 고정 너비 */\n  min-width: 250px; /* 최소 너비 설정 */\n  flex-shrink: 0; /* 크기 축소 방지 */\n  z-index: 10; /* 높은 z-index */\n  position: relative;\n  background-color: #f8f8f8;\n}\n\n/* 메인 콘텐츠 영역 */\n.mainContent {\n  flex: 1;\n  overflow: hidden; /* 스크롤은 내부 컴포넌트에서 처리 */\n  position: relative;\n  padding: 20px;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
